export default __webpack_public_path__ + "static/media/Opswat_Academy.3045445b.png";